export const CHAT_DICT = {
  es: {
    "msg.chats": "Chats",
    "msg.requests": "Solicitudes",
    "msg.emptyChats": "Aún no tienes conversaciones",
    "msg.emptyChatsSub": "Pulsa «Contactar» en cualquier anuncio para empezar a hablar.",
    "msg.emptyRequests": "No tienes solicitudes pendientes",
    "msg.emptyRequestsSub": "Aquí verás quién quiere escribirte desde tu perfil de Contactos.",
    "msg.wantsToMessage": "{name} quiere enviarte un mensaje",
    "msg.audio": "Audio {d}",
    "msg.you": "Tú: ",
    "msg.deletedUser": "Usuario eliminado",
    "msg.requestSent": "Solicitud enviada, esperando respuesta",
    "msg.requestSentSub": "Podrás seguir escribiendo cuando te respondan.",
    "msg.firstHint": "Es una solicitud: puedes enviar un primer mensaje (texto o audio). Podrás seguir cuando te respondan.",
    "msg.placeholder": "Escribe un mensaje...",
    "msg.send": "Enviar",
    "msg.viewProfile": "Ver perfil",
    "msg.reply": "Responder",
    "msg.reject": "Rechazar",
    "msg.block": "Bloquear",
    "msg.report": "Denunciar",
    "msg.delete": "Eliminar conversación",
    "msg.deleted": "Conversación eliminada",
    "msg.blocked": "Usuario bloqueado",
    "msg.blockedBanner": "Has bloqueado a este usuario. No podéis enviaros mensajes.",
    "msg.cantSend": "No es posible enviar mensajes en esta conversación.",
    "msg.rejected": "Solicitud rechazada",
    "msg.newFrom": "Nuevo mensaje de {name}",
    "msg.open": "Abrir",
    "msg.blockConfirm": "¿Bloquear a {name}?",
    "msg.blockConfirmSub": "No podrá volver a contactarte. Puedes desbloquearlo desde Ajustes.",
    "msg.deleteConfirm": "¿Eliminar esta conversación?",
    "msg.deleteConfirmSub": "Solo se elimina para ti; la otra persona la seguirá viendo.",
    "msg.requestIntro": "Solicitud de contacto",
    "msg.requestIntroSub": "Acepta para abrir el chat. Si la rechazas, no se le avisará.",
    "msg.more": "Más opciones",
    "msg.tooLong": "Máximo 2000 caracteres",
    "msg.openChat": "Abrir chat",
    "rec.ready": "Pulsa el micrófono para grabar (máx. 60 s)",
    "rec.recording": "Grabando",
    "rec.slide": "‹ Desliza para cancelar",
    "rec.limit": "Límite de 60 s alcanzado",
    "rec.denied": "Sin permiso para usar el micrófono. Actívalo en los ajustes del navegador para enviar audios.",
    "rec.unsupported": "Tu navegador no permite grabar audio.",
    "rec.uploading": "Enviando audio...",
    "rec.failed": "No se pudo enviar el audio",
    "rec.cancel": "Cancelar grabación",
    "rec.start": "Grabar audio",
    "rep.title": "Denunciar usuario",
    "rep.sub": "¿Qué ha pasado? Lo revisaremos lo antes posible.",
    "rep.reason.spam": "Spam",
    "rep.reason.inapropiado": "Contenido inapropiado",
    "rep.reason.menor": "Menor de edad",
    "rep.reason.acoso": "Acoso",
    "rep.reason.otro": "Otro",
    "rep.reason.perfil_falso": "Perfil falso / fotos que no son suyas",
    "profile.contactos": "Mi perfil de Contactos",
    "share.publishedTitle": "¡Anuncio publicado! 🎉",
    "share.publishedSub": "Compártelo en tus redes para que lo vea más gente",
    "share.title": "Compartir anuncio",
    "share.sub": "Envíalo a tus amigos o compártelo en tus redes",
    "share.share": "Compartir",
    "share.copy": "Copiar enlace",
    "share.copied": "Enlace copiado",
    "share.copiedSocial": "Enlace copiado. Pégalo en tu publicación o historia",
    "share.view": "Ver mi anuncio",
    "share.later": "Ahora no",
    "legal.section": "Legal",
    "legal.aviso-legal": "Aviso legal",
    "legal.privacidad": "Privacidad",
    "legal.cookies": "Cookies",
    "legal.condiciones": "Condiciones de uso",
    "legal.privacyPolicy": "Política de privacidad",
    "legal.updated": "Última actualización: {date}",
    "legal.cookieNotice": "Usamos solo cookies técnicas necesarias para que la web funcione.",
    "legal.moreInfo": "Más información",
    "legal.gotIt": "Entendido",
    "legal.accept1": "He leído y acepto las ",
    "legal.accept2": " y la ",
    "legal.mustAccept": "Debes aceptar las Condiciones de uso y la Política de privacidad",
    "legal.minAge": "Debes tener al menos 14 años para registrarte",
    "profile.createContactos": "Crear perfil",
    "contact.profileExists": "Ya tienes un perfil de Contactos. Puedes editarlo aquí.",
    "form.photosMissing": "Te faltan {x} fotos para poder pedir contacto",
    "contact.completeProfile": "Completa tu perfil para pedir contacto",
    "contact.needPhotos": "Necesitas {n} fotos en tu perfil (te faltan {x})",
    "form.realPhoto": "La foto principal es una foto real mía (no dibujos, paisajes ni fotos de otras personas)",
    "form.photoProgress": "{n}/{m} fotos",
    "form.photosNeeded": "Necesitas {m} para enviar solicitudes",
    "form.photosReady": "¡Perfil listo para pedir contacto!",
    "form.aboutHint": "Recomendado: escribe unas líneas sobre ti para que te acepten más fácilmente",
    "rep.detailsPh": "Cuéntanos más (opcional)",
    "rep.send": "Enviar denuncia",
    "rep.done": "Gracias. Hemos recibido tu denuncia.",
    "up.listings": "Anuncios de {name}",
    "up.noListings": "No tiene anuncios activos",
    "set.zone": "Zona por defecto",
    "set.password": "Cambiar contraseña",
    "set.createPassword": "Crear contraseña",
    "set.currentPw": "Contraseña actual",
    "set.newPw": "Nueva contraseña (mín. 6)",
    "set.pwSaved": "Contraseña actualizada",
    "set.pwWrong": "La contraseña actual no es correcta",
    "set.blocked": "Usuarios bloqueados",
    "set.noBlocked": "No has bloqueado a nadie",
    "set.unblock": "Desbloquear",
    "set.unblocked": "Usuario desbloqueado",
    "set.myData": "Mis datos",
    "set.delete": "Eliminar cuenta",
    "set.deleteTitle": "¿Eliminar tu cuenta?",
    "set.deleteSub": "Se borrarán tus anuncios y favoritos y tus mensajes quedarán anónimos. No se puede deshacer.",
    "set.deleteType": "Escribe {word} para confirmar",
    "set.deleteWord": "ELIMINAR",
    "set.deleteBtn": "Eliminar definitivamente",
    "set.deleted": "Tu cuenta se ha eliminado",
    "set.account": "Cuenta",
    "pw.forgot": "¿Olvidaste tu contraseña?",
    "pw.forgotTitle": "Recupera tu contraseña",
    "pw.forgotSub": "Te enviaremos un enlace para elegir una nueva. Caduca en 1 hora y solo sirve una vez.",
    "pw.sendLink": "Enviar enlace",
    "pw.sent": "Si existe una cuenta con ese email, te hemos enviado un enlace. Revisa también la carpeta de spam.",
    "pw.resetTitle": "Elige una nueva contraseña",
    "pw.repeat": "Repite la contraseña",
    "pw.mismatch": "Las contraseñas no coinciden",
    "pw.save": "Guardar contraseña",
    "pw.done": "Contraseña cambiada. Ya puedes iniciar sesión.",
    "pw.invalid": "El enlace no es válido o ha caducado. Pide uno nuevo.",
    "pw.backLogin": "Volver a iniciar sesión",
    "nav.swipeHint": "Desliza para ver los anuncios →",
    "mercat.resultsIn": "{n} anuncios en",
    "mercat.resultIn1": "1 anuncio en",
    "mercat.allListings": "Todos los anuncios",
    "msg.wantsToContact": "{name} quiere contactar contigo",
    "msg.accept": "Aceptar",
    "contact.request": "Pedir contacto",
    "contact.pending": "Solicitud enviada · esperando respuesta",
    "contact.cancel": "Cancelar solicitud",
    "contact.openChat": "Abrir chat",
    "contact.viewIncoming": "Ver su solicitud",
    "contact.needProfile": "Crea tu perfil de Contactos para poder pedir contacto",
    "contact.createProfile": "Crear mi perfil",
    "contact.sentToast": "Solicitud enviada",
    "contact.requestPreview": "Quiere contactar contigo",
    "contact.acceptedHint": "Solicitud aceptada. Ya podéis escribiros.",
    "contact.matchTitle": "¡Coincidencia!",
    "contact.matchTag": "Coincidencia",
    "msg.matches": "Coincidencias",
    "msg.emptyMatches": "Aún no hay coincidencias",
    "msg.emptyMatchesSub": "Cuando los dos pidáis contacto, aparecerá aquí.",
    "activity.title": "Tu actividad",
    "activity.messages": "Mensajes",
    "activity.requests": "Solicitudes",
    "activity.matches": "Coincidencias",
    "contact.matchSub": "Los dos queréis contactar",
    "contact.matchToast": "¡Coincidencia con {name}!",
    "contact.remaining": "Te quedan {n} solicitudes hoy",
    "contact.limitReached": "Has alcanzado el límite de {n} solicitudes por hoy. Vuelve mañana.",
  },
  en: {
    "msg.chats": "Chats",
    "msg.requests": "Requests",
    "msg.emptyChats": "No conversations yet",
    "msg.emptyChatsSub": "Tap “Contact” on any listing to start talking.",
    "msg.emptyRequests": "No pending requests",
    "msg.emptyRequestsSub": "Here you'll see who wants to write to you from your Contacts profile.",
    "msg.wantsToMessage": "{name} wants to send you a message",
    "msg.audio": "Audio {d}",
    "msg.you": "You: ",
    "msg.deletedUser": "Deleted user",
    "msg.requestSent": "Request sent, waiting for a reply",
    "msg.requestSentSub": "You can keep writing once they reply.",
    "msg.firstHint": "This is a request: you can send one first message (text or audio). You can continue once they reply.",
    "msg.placeholder": "Write a message...",
    "msg.send": "Send",
    "msg.viewProfile": "View profile",
    "msg.reply": "Reply",
    "msg.reject": "Decline",
    "msg.block": "Block",
    "msg.report": "Report",
    "msg.delete": "Delete conversation",
    "msg.deleted": "Conversation deleted",
    "msg.blocked": "User blocked",
    "msg.blockedBanner": "You blocked this user. Neither of you can send messages.",
    "msg.cantSend": "Messages can't be sent in this conversation.",
    "msg.rejected": "Request declined",
    "msg.newFrom": "New message from {name}",
    "msg.open": "Open",
    "msg.blockConfirm": "Block {name}?",
    "msg.blockConfirmSub": "They won't be able to contact you again. You can unblock them in Settings.",
    "msg.deleteConfirm": "Delete this conversation?",
    "msg.deleteConfirmSub": "It's only deleted for you; the other person will still see it.",
    "msg.requestIntro": "Contact request",
    "msg.requestIntroSub": "Accept to open the chat. If you decline, they won't be notified.",
    "msg.more": "More options",
    "msg.tooLong": "Maximum 2000 characters",
    "msg.openChat": "Open chat",
    "rec.ready": "Tap the mic to record (max 60 s)",
    "rec.recording": "Recording",
    "rec.slide": "‹ Slide to cancel",
    "rec.limit": "60 s limit reached",
    "rec.denied": "No permission to use the microphone. Enable it in your browser settings to send audio.",
    "rec.unsupported": "Your browser can't record audio.",
    "rec.uploading": "Sending audio...",
    "rec.failed": "Could not send the audio",
    "rec.cancel": "Cancel recording",
    "rec.start": "Record audio",
    "rep.title": "Report user",
    "rep.sub": "What happened? We'll review it as soon as possible.",
    "rep.reason.spam": "Spam",
    "rep.reason.inapropiado": "Inappropriate content",
    "rep.reason.menor": "Underage",
    "rep.reason.acoso": "Harassment",
    "rep.reason.otro": "Other",
    "rep.reason.perfil_falso": "Fake profile / not their photos",
    "profile.contactos": "My Contacts profile",
    "share.publishedTitle": "Listing published! 🎉",
    "share.publishedSub": "Share it on your networks so more people see it",
    "share.title": "Share listing",
    "share.sub": "Send it to your friends or share it on your networks",
    "share.share": "Share",
    "share.copy": "Copy link",
    "share.copied": "Link copied",
    "share.copiedSocial": "Link copied. Paste it in your post or story",
    "share.view": "View my listing",
    "share.later": "Not now",
    "legal.section": "Legal",
    "legal.aviso-legal": "Legal notice",
    "legal.privacidad": "Privacy",
    "legal.cookies": "Cookies",
    "legal.condiciones": "Terms of use",
    "legal.privacyPolicy": "Privacy policy",
    "legal.updated": "Last updated: {date}",
    "legal.cookieNotice": "We only use technical cookies needed for the website to work.",
    "legal.moreInfo": "More info",
    "legal.gotIt": "Got it",
    "legal.accept1": "I have read and accept the ",
    "legal.accept2": " and the ",
    "legal.mustAccept": "You must accept the Terms of use and the Privacy policy",
    "legal.minAge": "You must be at least 14 years old to sign up",
    "profile.createContactos": "Create profile",
    "contact.profileExists": "You already have a Contacts profile. You can edit it here.",
    "form.photosMissing": "You're missing {x} photos to request contact",
    "contact.completeProfile": "Complete your profile to request contact",
    "contact.needPhotos": "You need {n} photos on your profile ({x} missing)",
    "form.realPhoto": "The main photo is a real photo of me (no drawings, landscapes or photos of other people)",
    "form.photoProgress": "{n}/{m} photos",
    "form.photosNeeded": "You need {m} to send requests",
    "form.photosReady": "Profile ready to request contact!",
    "form.aboutHint": "Recommended: write a few lines about yourself so people accept you more easily",
    "rep.detailsPh": "Tell us more (optional)",
    "rep.send": "Send report",
    "rep.done": "Thanks. We've received your report.",
    "up.listings": "{name}'s listings",
    "up.noListings": "No active listings",
    "set.zone": "Default zone",
    "set.password": "Change password",
    "set.createPassword": "Create password",
    "set.currentPw": "Current password",
    "set.newPw": "New password (min. 6)",
    "set.pwSaved": "Password updated",
    "set.pwWrong": "Current password is incorrect",
    "set.blocked": "Blocked users",
    "set.noBlocked": "You haven't blocked anyone",
    "set.unblock": "Unblock",
    "set.unblocked": "User unblocked",
    "set.myData": "My details",
    "set.delete": "Delete account",
    "set.deleteTitle": "Delete your account?",
    "set.deleteSub": "Your listings and favourites will be removed and your messages anonymised. This can't be undone.",
    "set.deleteType": "Type {word} to confirm",
    "set.deleteWord": "DELETE",
    "set.deleteBtn": "Delete permanently",
    "set.deleted": "Your account has been deleted",
    "set.account": "Account",
    "pw.forgot": "Forgot your password?",
    "pw.forgotTitle": "Recover your password",
    "pw.forgotSub": "We'll email you a link to choose a new one. It expires in 1 hour and works once.",
    "pw.sendLink": "Send link",
    "pw.sent": "If an account exists for that email, we've sent you a link. Check your spam folder too.",
    "pw.resetTitle": "Choose a new password",
    "pw.repeat": "Repeat the password",
    "pw.mismatch": "Passwords don't match",
    "pw.save": "Save password",
    "pw.done": "Password changed. You can log in now.",
    "pw.invalid": "This link is invalid or has expired. Request a new one.",
    "pw.backLogin": "Back to log in",
    "nav.swipeHint": "Swipe to see the listings →",
    "mercat.resultsIn": "{n} listings in",
    "mercat.resultIn1": "1 listing in",
    "mercat.allListings": "All listings",
    "msg.wantsToContact": "{name} wants to contact you",
    "msg.accept": "Accept",
    "contact.request": "Request contact",
    "contact.pending": "Request sent · waiting for a reply",
    "contact.cancel": "Cancel request",
    "contact.openChat": "Open chat",
    "contact.viewIncoming": "See their request",
    "contact.needProfile": "Create your Contacts profile to be able to request contact",
    "contact.createProfile": "Create my profile",
    "contact.sentToast": "Request sent",
    "contact.requestPreview": "Wants to contact you",
    "contact.acceptedHint": "Request accepted. You can now write to each other.",
    "contact.matchTitle": "It's a match!",
    "contact.matchTag": "Match",
    "msg.matches": "Matches",
    "msg.emptyMatches": "No matches yet",
    "msg.emptyMatchesSub": "When you both request contact, it will show up here.",
    "activity.title": "Your activity",
    "activity.messages": "Messages",
    "activity.requests": "Requests",
    "activity.matches": "Matches",
    "contact.matchSub": "You both want to get in touch",
    "contact.matchToast": "It's a match with {name}!",
    "contact.remaining": "{n} requests left today",
    "contact.limitReached": "You've reached the limit of {n} requests for today. Come back tomorrow.",
  },
};

export const mmss = (s) => {
  const n = Math.max(0, Math.round(s || 0));
  return `${Math.floor(n / 60)}:${String(n % 60).padStart(2, "0")}`;
};

export const chatTime = (iso, lang) => {
  if (!iso) return "";
  const d = new Date(iso);
  const sameDay = d.toDateString() === new Date().toDateString();
  return sameDay
    ? d.toLocaleTimeString(lang, { hour: "2-digit", minute: "2-digit" })
    : d.toLocaleDateString(lang, { day: "numeric", month: "short" });
};
